module.exports = __webpack_public_path__ + "static/media/home_theater_layout.4031f490.jpg";